import { render, staticRenderFns } from "./c-products.vue?vue&type=template&id=58eaf40c"
import script from "./c-products.vue?vue&type=script&lang=js"
export * from "./c-products.vue?vue&type=script&lang=js"
import style0 from "./c-products.vue?vue&type=style&index=0&id=58eaf40c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports